import dayjs from 'dayjs';
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
var timezone = require('dayjs/plugin/timezone');
dayjs.extend(timezone);
var isSameOrBeforePlugin = require('dayjs/plugin/isSameOrBefore');
dayjs.extend(isSameOrBeforePlugin);
var isSameOrAfterPlugin = require('dayjs/plugin/isSameOrAfter');
dayjs.extend(isSameOrAfterPlugin);

export const isDateInFuture = function (value, compareBy = 'days') {
  var dateValue = dayjs.utc(value);
  var today = dayjs().utc();
  return dateValue.isAfter(today, compareBy);
};

export const getUtcDate = function (value) {
  // convert to local timezone from utc without changing the hours
  dayjs.tz.guess();
  let utcDate = dayjs.tz(value).toDate();
  dayjs.tz.setDefault(); // reset to default
  return utcDate;
};

export const isSameOrBefore = function (value, compareValue = null) {
  return dayjs.utc(value).isSameOrBefore(compareValue ?? dayjs.utc());
};

export const isBefore = function (value, compareValue = null) {
  return dayjs.utc(value).isBefore(compareValue ?? dayjs.utc());
};

export const isSameOrAfter = function (value, compareValue = null) {
  return dayjs.utc(value).isSameOrAfter(compareValue ?? dayjs.utc());
};
